import type { ReactNode } from 'react';

export const symbol_circles: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M438-80q-74 0-139.5-28t-114-76.5Q136-233 108-298.5T80-438q0-113 63-206.5T313-776q22-8 41.5 4.5t24.74 35.46Q384-715 372-696t-33 27q-70 29-112 92.5T185-438q0 106 73.5 179.5T438-185q77 0 142-41.5T674-340q8-20 25.5-32.5t37.68-7.79Q760-375 772-356t4 39q-38 108-131 172.5T438-80Zm247-840q97.5 0 165.75 68.35 68.25 68.36 68.25 166 0 97.65-68.35 166.15-68.36 68.5-166 68.5-97.65 0-166.15-68.54T450-686q0-97.5 68.54-165.75T685-920Zm-.5 364q51.5 0 90.5-39t39-90.5q0-51.5-39-90.5t-90.5-39q-51.5 0-90.5 39t-39 90.5q0 51.5 39 90.5t90.5 39Zm.5-130ZM439-437Z"
		/>
	</svg>
);
